import TourIcon from '@mui/icons-material/Tour';
import {
  Box,
  Divider,
  IconButton,
  LinearProgress,
  SxProps,
  Theme,
  Typography,
} from '@mui/material';
import { ShimmerButton } from '@parkdna/ui/buttons/shimmer/ShimmerButton';
import { memo } from 'react';

import { useSidebarStore } from '@/stores/sidebar';
import { useToursStore } from '@/stores/tours';

interface TakeTourButtonProps {
  /**
   * Additional styling for the container
   */
  sx?: SxProps<Theme>;
}

const TakeTourButton = memo(({ sx }: TakeTourButtonProps) => {
  const [setValidatorTourRun, getProgress, stepIndex, totalSteps] =
    useToursStore((state) => [
      state.setIsValidatorTourRun,
      state.getProgress,
      state.stepIndex,
      state.totalSteps,
    ]);
  const { isCollapsed } = useSidebarStore();
  const progress = getProgress();

  const handleTourClick = () => {
    setValidatorTourRun(true);
  };

  return (
    <Box sx={{ paddingX: 1, mb: 1, ...sx }}>
      {isCollapsed ? (
        <IconButton
          onClick={handleTourClick}
          aria-label="tour"
          color="primary"
          size="large"
        >
          <TourIcon />
        </IconButton>
      ) : (
        <ShimmerButton
          fullWidth
          variant="outlined"
          sx={{ padding: 1.25, textTransform: 'none' }}
          onClick={handleTourClick}
        >
          <Box sx={{ width: '100%' }}>
            <Typography
              variant="h4"
              component="p"
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
              }}
            >
              <TourIcon fontSize="small" />
              <Typography
                variant="h5"
                component="p"
                sx={{ verticalAlign: 'middle' }}
              >
                Take a tour
              </Typography>
            </Typography>
            {totalSteps > 0 && (
              <>
                <Divider sx={{ mt: 0.5 }} />
                <LinearProgress
                  variant="determinate"
                  value={progress}
                  sx={{ mt: 1.5, height: 4, borderRadius: 2 }}
                />
                <Typography variant="caption" sx={{ textAlign: 'left' }}>
                  Step {stepIndex + 1} of {totalSteps}
                </Typography>
              </>
            )}
          </Box>
        </ShimmerButton>
      )}
    </Box>
  );
});
TakeTourButton.displayName = 'TakeTourButton';

export default TakeTourButton;
